<template>
  <div :id="bannerId">
    <div
      v-if="isLoggedIn"
      class="anz-fc-alert anz-fc-alert-success anz-p-xl anz-my-xl anz-align-center anz-justify-content-center"
    >
      <div>
        <h6 class="anz-fs-xs anz-mb-m">
          {{ $translate('post.texts.subscribeHeading') }}
        </h6>
        {{ $translate('post.texts.loginText') }}
        <a-button
          :add-href="loginBannerFallbackDisabled"
          :href="generateSwitchAccountRoute(topic)"
          @click="propagateSwitchAccountEvent"
          class-name="anz-link anz-link-underline anz-font-bold anz-color-default"
        >
          <template #title>
            {{ $translate('post.texts.loginTextLink') }}
          </template>
        </a-button>
      </div>
    </div>
    <div v-else class="anz-bg-black-3 anz-p-xl anz-my-xl anz-align-center">
      <div>
        <h6 class="anz-fs-xs anz-mb-m">
          {{ $translate('post.texts.loginHeading') }}
        </h6>
        <a-button
          :add-href="loginBannerFallbackDisabled"
          :href="generateLoginRoute(topic)"
          @click.stop="propagateLoginEvent"
          class-name="anz-btn anz-btn-primary anz-btn-l anz-mb-m anz-px-xxl"
        >
          <template #title>
            {{ $translate('post.texts.loginBtnText') }}
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import AButton from '@/components/Forms/AButton'
import useCurrentUser from '@/composables/user/user'
import { useRouter } from '@/routing/router'
import { onMounted } from 'vue'
import useBannerManager, {
  useDefaultBannerActions,
} from '@/composables/banner/bannerManager'
import useTopic from '@/composables/topic/topic'
import { TopicStatus } from '@/model/data-object/TopicSettings'

export default {
  name: 'TopLoginBanner',
  components: { AButton },
  props: {
    placeHolder: {
      type: String,
      default: '',
    },
    showLoginLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TOPIC_STATUS_ACTIVE: TopicStatus.ACTIVE,
    }
  },
  setup() {
    const { topic } = useTopic()
    const {
      loginBannerDisabled,
      generateBannerId,
      propagateTopBannerEvent,
    } = useBannerManager()
    const {
      loginBannerFallbackDisabled,
      propagateLoginEvent,
      propagateSwitchAccountEvent,
    } = useDefaultBannerActions()

    const bannerId = generateBannerId()

    onMounted(() => {
      if (!loginBannerDisabled) {
        propagateTopBannerEvent(bannerId)
      }
    })

    return {
      topic,
      bannerId,
      loginBannerFallbackDisabled,
      loginBannerDisabled,
      ...useRouter(),
      ...useCurrentUser(),
      propagateLoginEvent,
      propagateSwitchAccountEvent,
    }
  },
}
</script>
